module.exports = __webpack_public_path__ + "static/media/checkmark-large.9e3a1488.svg";